const exampleTheme = {
  ltr: "text-left",
  rtl: "text-right",
  placeholder: "text-gray-400 overflow-hidden absolute top-3.5 left-2.5 text-base select-none inline-block pointer-events-none",
  paragraph: "relative",
  quote: "my-0 ml-5 text-base text-gray-400 border-l-4 border-gray-300 pl-4",
  heading: {
    h1: "text-3xl text-gray-900 font-normal my-0 mb-3 p-0",
    h2: "text-xl text-gray-900 font-bold my-0 mt-2.5 p-0",
    h3: "text-lg text-gray-900 font-normal my-0 mb-3",
    h4: "text-base text-gray-600 font-semibold my-0 mb-2 uppercase",
    h5: "text-sm text-gray-600 font-medium my-0 mb-2"
  },
  list: {
    nested: {
    listitem: "list-none"
    },
    ol: "p-0 m-0 ml-4 list-decimal",
    ul: "p-0 m-0 ml-4 list-disc",
    listitem: "my-2 mx-8"
  },
  image: "editor-image",
  link: "text-blue-600 no-underline",
  text: {
    bold: "font-bold",
    italic: "italic",
    overflowed: "editor-text-overflowed",
    hashtag: "editor-text-hashtag",
    underline: "underline",
    strikethrough: "line-through",
    underlineStrikethrough: "underline line-through",
    code: "bg-gray-200 p-0.5 px-1 font-mono text-sm"
  },
  code: "bg-gray-200 font-mono block p-2 mt-2 mb-2 leading-snug text-xs relative overflow-x-auto",
  codeHighlight: {
    atrule: "editor-tokenAttr",
    attr: "editor-tokenAttr",
    boolean: "editor-tokenProperty",
    builtin: "editor-tokenSelector",
    cdata: "editor-tokenComment",
    char: "editor-tokenSelector",
    class: "editor-tokenFunction",
    "class-name": "editor-tokenFunction",
    comment: "editor-tokenComment",
    constant: "editor-tokenProperty",
    deleted: "editor-tokenProperty",
    doctype: "editor-tokenComment",
    entity: "editor-tokenOperator",
    function: "editor-tokenFunction",
    important: "editor-tokenVariable",
    inserted: "editor-tokenSelector",
    keyword: "editor-tokenAttr",
    namespace: "editor-tokenVariable",
    number: "editor-tokenProperty",
    operator: "editor-tokenOperator",
    prolog: "editor-tokenComment",
    property: "editor-tokenProperty",
    punctuation: "editor-tokenPunctuation",
    regex: "editor-tokenVariable",
    selector: "editor-tokenSelector",
    string: "editor-tokenSelector",
    symbol: "editor-tokenProperty",
    tag: "editor-tokenProperty",
    url: "editor-tokenOperator",
    variable: "editor-tokenVariable"
  }
  };
  
  export default exampleTheme;
  